import type { BonusesResponse } from './PromoService.types';
import { BaseService, defineApi } from '@/shared/api';

class PromoService extends BaseService {
  /** https://qicbizdev.atlassian.net/wiki/spaces/QB/pages/1597669377 */
  async fetchAvailableBonuses(payload: { locale: string }): Promise<BonusesResponse> {
    const legacyUrl = import.meta.env.VUE_APP_API_LEGACY_URL;

    if (!legacyUrl) {
      throw new Error('legacy URL is not defined');
    }

    return this.get('/bonus/availableBonusesAndPrizes', {
      baseURL: legacyUrl,
      headers: {
        'Qic-Product-Code': 'bonus',
        'Language': payload.locale,
        'Source-ID': '1',
      },
    });
  }
}

export const usePromoService = defineApi(PromoService);
